/* clickable-qty-clamp -- SITEWIDE quantity clamp at input time
   (FID-05 r5 item 2, canon amendment ratified by Lucas).

   Contract:
   - Render-time: tracked, deny-policy variants carry max + data-ck-max
     on the qty input (PDP buy area, cart page lines, drawer lines --
     the drawer max is embedded in the clickable-cart-drawer section
     render because the AJAX cart carries no inventory). Untracked /
     continue-selling inputs carry no data-ck-max and are untouched.
   - Input-time: typed entry above max clamps to max ON INPUT and shows
     "Only {N} available" in the amber message slot ([data-ck-qty-msg],
     reserved-height, zero-CLS). Auto-clears when qty is in range.
     Plus-button disabling is native: Dawn's validateQtyRules disables
     at input.max on cart surfaces; the PDP stepper script mirrors it.
   - Response is truth: on every cart qty AJAX (page + drawer) the
     stepper repaints from Shopify's RESPONSE quantity, never the
     requested value. Response < requested (server-side clamp -- stock
     moved since render) also shows the amber message with the response
     max and tightens max/data-ck-max to it. Kills the must-reload bug
     both on Dawn's errors path (which returns before the section swap)
     and the silent-clamp path (which compares against a detached
     pre-swap node).
   - Backstop untouched: ATC-time server checks and add.js error
     handling are not modified anywhere.

   Loaded by: clickable-product.liquid, clickable-cart-items.liquid,
   clickable-cart-drawer.liquid -- full bundle (js + css) travels with
   every surface, per CLAUDE.md rule 21. */
(function () {
  'use strict';

  /* rule-21 multi-surface loading (PDP section + cart section + drawer
     snippet can coexist on one page = multiple same-src script tags,
     which classic scripts execute PER TAG): run once. Without this the
     second capture listener re-reads the just-clamped value and
     immediately clears the message (caught live in r5). */
  if (window.__ckQtyClampLoaded) return;
  window.__ckQtyClampLoaded = true;

  /* requested-per-line, captured at change time (capture phase runs
     before Dawn's cart change handler) so the cartUpdate hook can
     detect a server-side clamp */
  var pending = {};

  function slotFor(input) {
    /* nearest-surface slot: cart/drawer line first, then the PDP buy
       form (never the bare document — the drawer renders BEFORE main,
       so a document-wide first-match would hit a drawer slot from the
       PDP; caught live in r5) */
    var row = input.closest('[data-ck-qty-row]') || input.closest('.cart-item') || input.closest('form');
    return row ? row.querySelector('[data-ck-qty-msg]') : null;
  }
  function showMsg(input, msg) {
    var el = slotFor(input);
    if (!el) return;
    /* idempotent — the at-max sweep runs from a MutationObserver; a
       same-state write would re-trigger it (loop guard, r7) */
    if (el.textContent === msg && !el.hidden) return;
    el.textContent = msg;
    el.hidden = false;
  }
  /* ONE copy string, every surface (Lucas ruling, 11 Aug — supersedes
     'Only N available'): the live-store pattern, count substituted. */
  function stockMsg(n) {
    return "Quantity not available. We're sorry, we currently have " + n + ' in stock.';
  }
  window.clickableStockMsg = stockMsg;
  function show(input, n) {
    showMsg(input, stockMsg(n));
  }
  function clear(input) {
    var el = slotFor(input);
    if (el && !el.hidden) el.hidden = true;
  }
  /* Dawn's pubsub: publish/subscribe are function declarations (window
     properties) but PUB_SUB_EVENTS is a top-level const — a BARE
     identifier, NOT window.PUB_SUB_EVENTS (caught live in r5: the
     window-guarded calls silently never ran). Guard with typeof. */
  function republishQtyRules() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.quantityUpdate) {
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
    }
    document.dispatchEvent(new CustomEvent('clickable:qty-max-changed'));
  }
  /* SUPERSEDED r7 item 4 (Lucas, 27 Aug): the warning fires ONLY when
     the line quantity EXCEEDS available stock (stock dropped after the
     add) — never at equality. The r7 persistent at-max notice composed
     with the 11 Aug one-string ruling into a false error ("Quantity not
     available … 1 in stock") on a full-stock qty-1 line. Sitting AT max
     is silent; an exceed ATTEMPT still messages transiently via
     clampInput; the disabled plus stands alone. Cart page + drawer
     (both are updates[] inputs). */
  function isCartLine(input) { return input.name === 'updates[]'; }
  function syncAtMax(input) {
    var max = parseInt(input.getAttribute('data-ck-max'), 10);
    if (isNaN(max) || max < 1) return;
    var v = parseInt(input.value, 10);
    if (isNaN(v)) { clear(input); return; }
    /* At EQUALITY leave the painted state alone: a clean at-max line
       stays silent (nothing was ever painted), while the transient
       message an exceed-attempt just painted (clampInput snaps the
       value to max, then the change event re-enters here at v == max)
       survives — the same wipe-guard shape as the PDP path below. */
    if (v > max) show(input, max);
    else if (v < max) clear(input);
  }
  function sweepAtMax() {
    document.querySelectorAll('input[name="updates[]"][data-ck-max]').forEach(syncAtMax);
  }
  /* ---- ADMIN QUANTITY RULES join the clamp (bubble-leak round, item 4).
     Rule attrs are server-rendered on cart-line inputs (page + drawer):
     data-min = quantity_rule.min, step = quantity_rule.increment,
     max = quantity_rule.max (stock-tightened into data-ck-max when the
     variant is tracked-deny). Typed values SNAP to the nearest valid
     quantity at input time — Dawn's bubble-phase validateQuantity then
     always sees a valid value, so its setCustomValidity/reportValidity
     path never fires (the amber slot is the only message voice, ruled).
     v1 strings — copy-era workbook with the rest. */
  function rulesOf(input) {
    var step = parseInt(input.getAttribute('step'), 10);
    var min = parseInt(input.getAttribute('data-min'), 10);
    var stockMax = parseInt(input.getAttribute('data-ck-max'), 10);
    var ruleMax = parseInt(input.getAttribute('max'), 10);
    if (isNaN(step) || step < 1) step = 1;
    if (isNaN(min) || min < 1) min = 1;
    var max = Infinity;
    if (!isNaN(stockMax) && stockMax >= 1) max = stockMax;
    if (!isNaN(ruleMax) && ruleMax >= 1 && ruleMax < max) max = ruleMax;
    return { step: step, min: min, max: max, stockMax: (!isNaN(stockMax) && stockMax >= 1) ? stockMax : null };
  }

  function clampInput(input) {
    var r = rulesOf(input);
    var v = parseInt(input.value, 10);
    if (isNaN(v)) {
      /* emptied/garbage: restore the last server truth silently (Dawn's
         own reset semantic) — never a message, never a native bubble */
      var last = parseInt(input.getAttribute('value'), 10);
      if (!isNaN(last)) input.value = last;
      return;
    }
    var snapped = Math.round(v / r.step) * r.step;
    if (snapped < r.min) snapped = r.min;
    if (snapped > r.max && r.max !== Infinity) {
      snapped = Math.floor(r.max / r.step) * r.step;
      if (snapped < r.min) snapped = r.min;
    }
    if (snapped !== v) {
      input.value = snapped;
      /* message priority: stock cap keeps the standing copy; then the
         rule that actually rewrote the value */
      if (v > r.max && r.stockMax !== null && r.max === r.stockMax) show(input, r.stockMax);
      else if (v > r.max && r.max !== Infinity) showMsg(input, 'Maximum of ' + r.max + ' per order');
      else if (r.step > 1 && v % r.step !== 0) showMsg(input, 'Sold in packs of ' + r.step);
      else if (v < r.min) showMsg(input, 'Minimum of ' + r.min + ' per order');
      republishQtyRules();
    } else if (isCartLine(input)) {
      syncAtMax(input); /* persistent at-max semantics on cart lines */
    } else if (v < r.max) {
      /* LIVE STATE (Lucas, 11 Aug round 1): only dropping UNDER max
         clears. At max the in-range change event must not wipe the
         copy the exceed-attempt just painted (input clamps+paints,
         change re-read the clamped value and cleared it — the same
         shape as the r5 double-execution bug, this time from the
         module's own input+change pair). */
      clear(input);
    }
  }

  /* Belt (ruled: NO native bubble in cart scope, ever): even a path the
     snap can't reach must not surface a browser tooltip — mute
     reportValidity per cart-line input. The amber slots carry every
     message; checkout stays the binding truth. Inputs are REPLACED by
     truth swaps, so the mute is re-applied from the same observer that
     re-sweeps at-max. */
  function muteNativeValidity(input) {
    if (input.__ckMuted) return;
    input.__ckMuted = true;
    input.reportValidity = function () { return true; };
  }
  function sweepMute() {
    document.querySelectorAll('input[name="updates[]"]').forEach(muteNativeValidity);
  }

  var CLAMP_MATCH = 'input[data-ck-max], input[name="updates[]"]';
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches(CLAMP_MATCH)) clampInput(t);
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches(CLAMP_MATCH)) {
      clampInput(t);
      var idx = t.getAttribute('data-index');
      if (idx) pending[idx] = parseInt(t.value, 10);
    }
  }, true);

  /* response is truth (item 2c).
     TWO server shapes, both handled (verified live on the draft):
     - silent clamp: change.js returns the cart (items array) — paint
       inputs from response quantities directly.
     - clamp WITH errors (the must-reload bug): Shopify applies the
       clamp server-side AND returns an errors-only payload; Dawn's
       error path resets the input to the STALE value attribute,
       SKIPS the section swap, and publishes cartUpdate without items.
       Here: fetch /cart.js truth, queue the clamp messages, republish
       cartUpdate under our own source so Dawn's onCartUpdate refetches
       and re-renders every section server-true (inputs, totals,
       sticky bar), then paint the queued messages onto the fresh DOM
       (MutationObserver on the persistent swap containers). */
  var queued = null;
  function applyQueued() {
    if (!queued) return;
    var q = queued;
    queued = null;
    Object.keys(q).forEach(function (line) {
      var input = document.getElementById('Quantity-' + line) || document.getElementById('Drawer-quantity-' + line);
      if (!input) return;
      var n = q[line];
      input.value = n;
      input.setAttribute('data-ck-max', n);
      input.setAttribute('max', n);
      show(input, n);
    });
    republishQtyRules();
  }
  function truthPaint(cartData) {
    cartData.items.forEach(function (item, i) {
      var line = String(i + 1);
      var input = document.getElementById('Quantity-' + line) || document.getElementById('Drawer-quantity-' + line);
      if (!input) return;
      var truth = item.quantity;
      if (parseInt(input.value, 10) !== truth) input.value = truth;
      var req = pending[line];
      if (req != null && truth < req) {
        input.setAttribute('data-ck-max', truth);
        input.setAttribute('max', truth);
        show(input, truth);
        republishQtyRules();
      }
    });
    pending = {};
  }
  /* self-refresh from OUR OWN sections (never Dawn's onCartUpdate: its
     page path hardcodes section_id=main-cart-items = the STOCK Dawn
     section file, which would degrade the canon cart — caught live in
     r5). Mirrors what cart.js updateQuantity itself swaps:
     - page: cart_url?section_id={#main-cart-items[data-id]} -> .js-contents
     - drawer: cart_url?section_id=cart-drawer -> .drawer__inner
       (the r4-repointed endpoint renders the canon snippet)
     - badge: section_id=cart-icon-bubble -> #cart-icon-bubble slot */
  function refreshSurface(sectionId, selector, targetEl) {
    var base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    return fetch(base + '?section_id=' + encodeURIComponent(sectionId))
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.querySelector(selector);
        if (source && targetEl) targetEl.innerHTML = source.innerHTML;
      });
  }
  window.clickableCartRefresh = function () { return refreshTruth(); };
  /* COUNTER FIX (11 Aug quantity round): EVERY successful add fires
     clickable:toast-shown (PDP form + card quick-add both voice the
     toast) -- refresh the three cart surfaces from server truth there.
     Dawn's own renderContents dies against the canon drawer markup
     (drawer swap first, badge swap never reached), so the badge went
     stale on every add path until reload. */
  document.addEventListener('clickable:toast-shown', function () { refreshTruth(); });
  function refreshTruth() {
    var jobs = [];
    var main = document.getElementById('main-cart-items');
    var pageContents = main && main.querySelector('.js-contents');
    if (main && pageContents && main.dataset.id) {
      jobs.push(refreshSurface(main.dataset.id, '.js-contents', pageContents));
    }
    var drawerInner = document.querySelector('cart-drawer .drawer__inner');
    if (drawerInner) {
      jobs.push(refreshSurface('cart-drawer', '.drawer__inner', drawerInner));
    }
    var bubbleSlot = document.getElementById('cart-icon-bubble');
    if (bubbleSlot) {
      jobs.push(refreshSurface('cart-icon-bubble', '.shopify-section', bubbleSlot));
    }
    return Promise.all(jobs);
  }
  function handleCartUpdate(ev) {
    var cartData = ev && ev.cartData;
    if (cartData && Array.isArray(cartData.items)) { truthPaint(cartData); return; }
    if (!Object.keys(pending).length) return;
    var req = pending; pending = {};
    var base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    fetch(base + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        queued = {};
        cart.items.forEach(function (item, i) {
          var line = String(i + 1);
          if (req[line] != null && item.quantity < req[line]) queued[line] = item.quantity;
        });
        return refreshTruth();
      })
      .then(function () { applyQueued(); })
      .catch(function () { queued = null; });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
  }
  /* deferred-message paint after Dawn's refresh swap + at-max re-sweep
     on every swap (server renders at-max lines with no message — the
     sweep restores it; r7 item 4); the custom elements persist across
     swaps, so observe them */
  var sweepTimer = null;
  function queueSweep() {
    clearTimeout(sweepTimer);
    sweepTimer = setTimeout(function () { sweepAtMax(); sweepMute(); }, 60);
  }
  document.addEventListener('DOMContentLoaded', function () {
    ['cart-items', 'cart-drawer'].forEach(function (tag) {
      var el = document.querySelector(tag);
      if (el) new MutationObserver(function () { applyQueued(); queueSweep(); }).observe(el, { childList: true, subtree: true });
    });
    sweepAtMax(); /* initial paint: server may render lines already at max */
    sweepMute(); /* native-validity mute on every cart-line input (re-applied per truth swap) */
  });
})();
